import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import BaseMultipleEntitySelector from '../../base-multiple-entity-selector-0000/1.1.2/index.vue';
import web_common_area_getStoreAreaTree
    from "../../../../lib/data-service/default/web_common_area_getStoreAreaTree";

export default {
    components: {
        BaseMultipleEntitySelector,
    },
    props: {
        value: {
            type: Array,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            value_for_v_model: null,
        };
    },
    watch: {
        value(pNewValue, pOldValue) {
            const __this = this;
            __this.value_for_v_model = pNewValue;
        },
        value_for_v_model(pNewValue, pOldValue) {
            const __this = this;
            __this.$emit('input', pNewValue);
        },
    },
    methods: {
        get_selected_entity_list(pParameter) {
            const __this = this;
            return __this.$refs.aBaseMultipleEntitySelector.get_selected_entity_list(pParameter);
        },
    },
    created() {
    },
    mounted() {
        const __this = this;
        __this.$refs.aBaseMultipleEntitySelector.init({
            entity_define: {
                property_name_for_id: `id`,
                property_name_for_code: `id`,
                property_name_for_name: `areaName`,
                property_name_for_pin_yin: `spell`,
                property_name_for_jian_pin: `spellInitial`,
                property_name_for_first_letter: `initial`,
            },
            get_data_source() {
                return Q.when()
                    .then(function () {
                        return web_common_area_getStoreAreaTree();
                    })
                    .then(function (data) {
                        const all_entity_list = data.storeAreaTreeResults;

                        const o = {};
                        o.all_entity_list = all_entity_list;
                        return o;
                    })
                    ;
            },
            panel_select_entity: {
                max_selected_entity_count: 10,
                event_handler_over_max_selected_entity_count(p) {
                    const max_selected_entity_count = p.max_selected_entity_count;
                    __this.$message({
                        message: `最多只能选择${max_selected_entity_count}个城市！`,
                        type: `error`,
                    });
                },
                get_tab_list(pParameter) {
                    if (!pParameter) pParameter = {};
                    const all_entity_list = pParameter.all_entity_list;
                    const init_parameter = pParameter.init_parameter;
                    const property_name_for_name = init_parameter.entity_define.property_name_for_name;
                    const property_name_for_first_letter = init_parameter.entity_define.property_name_for_first_letter;

                    const hot_entity_name_list = ["北京市", "长春市", "长沙市", "成都市", "重庆市", "福州市", "广州市", "贵阳市", "哈尔滨市", "海口市", "杭州市", "合肥市", "呼和浩特市", "济南市", "昆明市", "兰州市", "拉萨市", "南昌市", "南京市", "南宁市", "上海市", "沈阳市", "石家庄市", "太原市", "天津市", "武汉市", "乌鲁木齐市", "厦门市", "西安市", "西宁市", "银川市"];

                    const hot_entity_list = _.chain(all_entity_list)
                        // .filter(function (m, index) {
                        //     return 1 === 1
                        //         && m.isHot
                        //         ;
                        // })
                            .filter(function (m) {
                                const name = m[property_name_for_name];
                                return 1 === 1
                                    && _.contains(hot_entity_name_list, name)
                                    ;
                            })
                            .value()
                    ;

                    const first_letter_list = _.chain(all_entity_list)
                        .groupBy(function (m) {
                            return m[property_name_for_first_letter];
                        })
                        .map(function (property_value, property_name) {
                            const first_letter = property_name;
                            const entity_list = property_value;
                            const o = {};
                            o.first_letter = first_letter;
                            o.entity_list = entity_list;
                            return o;
                        })
                        .value()
                    ;
                    // console.log(first_letter_list);
                    // return;

                    const tab_list_001 = [
                        {
                            first_letter_list: [
                                {first_letter: `A`},
                                {first_letter: `B`},
                                {first_letter: `C`},
                                {first_letter: `D`},
                            ],
                        },
                        {
                            first_letter_list: [
                                {first_letter: `E`},
                                {first_letter: `F`},
                                {first_letter: `G`},
                                {first_letter: `H`},
                                {first_letter: `I`},
                            ],
                        },
                        {
                            first_letter_list: [
                                {first_letter: `J`},
                                {first_letter: `K`},
                                {first_letter: `L`},
                                {first_letter: `M`},

                            ],
                        },
                        {
                            first_letter_list: [
                                {first_letter: `N`},
                                {first_letter: `O`},
                                {first_letter: `P`},
                                {first_letter: `Q`},
                                {first_letter: `R`},
                                {first_letter: `S`},

                            ],
                        },
                        {
                            first_letter_list: [
                                {first_letter: `T`},
                                {first_letter: `U`},
                                {first_letter: `V`},
                                {first_letter: `W`},
                                {first_letter: `X`},
                            ],
                        },
                        {
                            first_letter_list: [
                                {first_letter: `Y`},
                                {first_letter: `Z`},
                            ],
                        },
                    ];

                    const tab_list_002 = _.chain(tab_list_001)
                        .map(function (m) {
                            const first_letter_list = m.first_letter_list;
                            const title = _.chain(first_letter_list)
                                .map(function (m) {
                                    return m.first_letter;
                                })
                                .value()
                                .join(``)
                            ;

                            const o = {};
                            o.type = `multiple-letters`;
                            o.title = title;
                            o.first_letter_list = first_letter_list;
                            return o;
                        })
                        .value()
                    ;
                    // console.log(tab_list_002);

                    const tab_list_003 = [
                        {
                            type: `hot-entity`,
                            title: `热门`,
                            hot_entity_list: hot_entity_list,
                        },
                        ...tab_list_002,
                    ];
                    // console.log(tab_list_003);

                    const tab_list_004 = _.chain(tab_list_003)
                        .map(function (m) {
                            m.active = false;
                            return m;
                        })
                        .value()
                    ;

                    const all_first_letter_list = _.chain(tab_list_002)
                        .map(function (m) {
                            return m.first_letter_list;
                        })
                        .flatten()
                        .map(function (m) {
                            const first_letter = m.first_letter;
                            // const entity_list = m.entity_list;

                            let entity_list = [];
                            const query = _.chain(first_letter_list)
                                .find(function (m) {
                                    return m.first_letter === first_letter;
                                })
                                .value()
                            ;
                            if (query) {
                                entity_list = query.entity_list;
                            }

                            m.entity_list = entity_list;
                            return m;
                        })
                        .value()
                    ;
                    // console.log(all_first_letter_list);

                    const tab_list = tab_list_004;
                    // console.log(tab_list);

                    const o = {};
                    o.tab_list = tab_list;
                    return Q.resolve(o);

                },
            },
            panel_filter_entity: {
                title: `名称/全拼/简拼`,
                is_show_code: false,
            },
        });
    },
}
